class AccordionFooter {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let w = $(window).width();
    if(w <= 768){
      $("." + this.el).on('click', function() {
        $(this).toggleClass('is-active').next().slideToggle();
      })
    }
  }
}